import PropTypes from 'prop-types'

const Checkbox = ({ name, value, checked, onChange, disabled = false }) => {
  const chequeado = value ? value[name] : checked
  return (
    <input
      type="checkbox"
      name={name}
      checked={chequeado}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default Checkbox
